import { useMemo } from "react";

interface LogoProps {
  className?: string;
  variant?: "full" | "compact";
  light?: boolean;
}

export default function Logo({ className = "", variant, light = false }: LogoProps) {
  const isCompact = useMemo(() => {
    if (variant) return variant === "compact";
    return false;
  }, [variant]);

  const textColor = light ? "text-white" : "text-[#143A66]";

  return (
    <a href="/" className={`flex items-center gap-2 md:gap-3 ${className}`} aria-label="Dépan'Volets Strasbourg - Accueil">
      {/* Icône SVG carrée : volet roulant */}
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-9 h-9 md:w-10 md:h-10 flex-shrink-0">
        {/* Fond carré bleu */}
        <rect width="40" height="40" rx="8" fill="#143A66"/>
        {/* Lames horizontales */}
        <rect x="5" y="5" width="30" height="4" rx="2" fill="#EAF1F8"/>
        <rect x="5" y="11" width="30" height="4" rx="2" fill="#D4E2F0"/>
        <rect x="5" y="17" width="30" height="4" rx="2" fill="#EAF1F8"/>
        {/* Lame cyan */}
        <rect x="5" y="23" width="30" height="4" rx="2" fill="#00B3A4"/>
        <rect x="5" y="29" width="30" height="4" rx="2" fill="#D4E2F0"/>
        {/* Petite poignée cercle */}
        <circle cx="32" cy="33" r="2.5" fill="#00B3A4"/>
      </svg>

      {/* Texte */}
      <div className="flex flex-col leading-none">
        <span className={`${textColor} font-bold text-base md:text-lg tracking-tight min-w-0`}>
          Dépan<span className="text-[#00B3A4]">’</span>Volets
        </span>
        {!isCompact && (
          <span className="text-[#00B3A4] font-semibold text-[10px] md:text-[11px] tracking-[0.2em] uppercase mt-0.5 min-w-0">
            STRASBOURG
          </span>
        )}
      </div>
    </a>
  );
}